import { useMemo } from "react"
import { GraphQLClient } from "graphql-request"
import { ENDPOINTS } from "../utils/endpoints"
import { useSession } from "./useSession"

export function useGraphQLClient() {
  const { session } = useSession()
  const client = useMemo(() => {
    return new GraphQLClient(ENDPOINTS.GRAPHQL, {
      headers: session?.jwt
        ? {
            Authorization: `Bearer ${session.jwt}`,
          }
        : undefined,
    })
  }, [session?.jwt])

  return client
}
